import baseAPI from "../api";
import { Organization } from "../organization/organizationModel";
import {
  InvitePremiumSponsorshipsResult,
  PremiumSponsorship,
  PremiumSponsorshipPreview,
} from "./premiumSponsorshipModel";

export function invitePremiumSponsorshipsRequest(
  organizationId: Organization["id"],
  emails: string[],
): Promise<InvitePremiumSponsorshipsResult> {
  return baseAPI
    .post(`/organization/${organizationId}/premium-sponsorships`, { emails })
    .then(({ data }) => data);
}

export function getPremiumSponsorshipsRequest(
  organizationId: Organization["id"],
): Promise<PremiumSponsorship[]> {
  return baseAPI
    .get(`/organization/${organizationId}/premium-sponsorships`)
    .then(({ data }) => data);
}

export function revokePremiumSponsorshipRequest(
  organizationId: Organization["id"],
  id: PremiumSponsorship["id"],
): Promise<void> {
  return baseAPI.post(
    `/organization/${organizationId}/premium-sponsorships/${id}/revoke`,
  );
}

export function resendPremiumSponsorshipInvitationRequest(
  organizationId: Organization["id"],
  id: PremiumSponsorship["id"],
): Promise<void> {
  return baseAPI.post(
    `/organization/${organizationId}/premium-sponsorships/${id}/resend`,
  );
}

export function deletePremiumSponsorshipRequest(
  organizationId: Organization["id"],
  id: PremiumSponsorship["id"],
): Promise<void> {
  return baseAPI.delete(
    `/organization/${organizationId}/premium-sponsorships/${id}`,
  );
}

export function getPremiumSponsorshipByTokenRequest(
  token: string,
): Promise<PremiumSponsorshipPreview> {
  return baseAPI
    .get(`/premium-sponsorships/token/${token}`)
    .then(({ data }) => data);
}

export function declinePremiumSponsorshipRequest(token: string): Promise<void> {
  return baseAPI.post(`/premium-sponsorships/token/${token}/decline`);
}

export function acceptPremiumSponsorshipRequest(token: string): Promise<void> {
  return baseAPI.post(`/premium-sponsorships/token/${token}/accept`);
}

export function getMyPremiumSponsorshipsRequest(): Promise<
  PremiumSponsorship[]
> {
  return baseAPI.get(`/premium-sponsorships/mine`).then(({ data }) => data);
}

export function renouncePremiumSponsorshipRequest(
  id: PremiumSponsorship["id"],
): Promise<void> {
  return baseAPI.post(`/premium-sponsorships/${id}/renounce`);
}
